// Marketplace domain constants: products, categories, resource types and
// access management. User-visible copy lives in common/copy.js.

export const Product = {
  Names: {
    PellerexSoftwareFoundation: "pellerex-software-foundation",
    NotConfigured: "not-configured-api-endpoint",
    ValidNameRegEx: /^[a-z0-9A-Z]{0,100}$/,
  },
  Category: {
    Foundation: "Foundation",
    API: "API",
    Service: "Service",
    ManagedApi: "ManagedApi",
    ManagedApp: "ManagedApp",
  },
  Associations: {
    SubscriptionBelongsToAssociatedProduct:
      "SubscriptionBelongsToAssociatedProduct",
  },
  Pricing: {
    // PriceLimit.Type values, mirroring the full CommonLayer
    // Constants.Marketplace.Products.Pricing.LimitTypes vocabulary.
    LimitTypes: {
      MaximumNumberOfUsers: "maximum-number-of-users",
      MaximumNumberOfCalls: "maximum-number-of-calls",
      MaximumNumberOfApis: "maximum-number-of-apis",
      MaximumNumberOfApps: "maximum-number-of-apps",
      MaximumNumberOfCallsConsumingTheProduct:
        "maximum-number-of-calls-consuming-the-product",
      MaximumNumberOfTenants: "maximum-number-of-tenants",
      MaximumNumberOfOrganisations: "maximum-number-of-organisations",
      LevelOfDevOpsIncluded: "level-of-devops-included",
      LevelOfIdentityIncluded: "level-of-identity-included",
      LevelOfABTestingIncluded: "level-of-ab-testing-included",
      IsSecretManagementIncluded: "is-secret-management-included",
      IsInfraMonitoringIncluded: "is-infra-monitoring-included",
      IsUsageMonitoringIncluded: "is-usage-monitoring-included",
      IsTicketSupportIncluded: "is-ticket-support-included",
      IsVideoChatSupportIncluded: "is-video-chat-support-included",
      IsDatabaseManagementIncluded: "is-database-management-included",
      IsApplicationAnalyticsIncluded: "is-application-analytics-included",
      IsVulnerabilityManagementIncluded:
        "is-vulnerability-management-included",
      IsPlatformAnalyticsIncluded: "is-platform-analytics-included",
      IsMcpIncluded: "is-mcp-included",
      MaximumAmountOfRamAllowed: "maximum-amount-of-ram-included",
      MaximumAmountOfComputeAllowed: "maximum-amount-of-compute-included",
      TypeOfComputeIncluded: "type-of-compute-included",
      MaximumArtefactStorage: "maximum-artefact-storage",
      MaximumNumberOfComputeSlots: "maximum-number-of-compute-slots",
      MaximumNumberOfTokens: "maximum-number-of-tokens",
      MaximumNumberOfRuntimeSeconds: "maximum-number-of-runtime-seconds",
      MaximumNumberOfTraces: "maximum-number-of-traces",
    },
    // PriceLimit.Interval values, mirroring CommonLayer UsageInterval.
    Intervals: {
      Monthly: "Monthly",
      Daily: "Daily",
      Hourly: "Hourly",
    },
  },
  WellKnown: {
    ManagedApi: {
      NormalisedName: "managed-api-service",
      JobTemplateIntents: {
        ProvisionManagedApiService: "ProvisionManagedApiService",
      },
      Actions: {
        ProvisionNewApi: "managed-api-service:provision-new",
        AccessSecretManagement: "managed-api-service:access-secret-management",
        AccessDatabaseManagement: "managed-api-service:access-database-management",
        AccessApplicationAnalytics: "managed-api-service:access-application-analytics",
      },
    },
    ManagedApp: {
      NormalisedName: "managed-app-service",
      JobTemplateIntents: {
        ProvisionManagedAppService: "ProvisionManagedAppService",
      },
      Actions: {
        ProvisionNewApp: "managed-app-service:provision-new",
        AccessApplicationAnalytics: "managed-app-service:access-application-analytics",
      },
    },
    ManagedIdentity: {
      NormalisedName: "managed-identity-service",
    },
    ManagedPayment: {
      NormalisedName: "managed-payment-service",
    },
    McpAgentIntegration: {
      NormalisedName: "mcp-agent-integration",
      Actions: {
        ManageMcpTools: "mcp-agent-integration:manage-mcp-tools",
        ManageMcpEndpoints: "mcp-agent-integration:manage-mcp-endpoints",
        ConsumeMcp: "mcp-agent-integration:consume-application",
      },
    },
    Shared: {
      JobTemplateIntents: {
        ApplicationPackageDependencyVulnerabilityScan: "ApplicationPackageDependencyVulnerabilityScan",
        ApplicationPackageEolScan: "ApplicationPackageEolScan",
        ApplicationDevSecOpsMaturityScan: "ApplicationDevSecOpsMaturityScan",
        ApplicationStandardsScan: "ApplicationStandardsScan",
        ApplicationTestCoverageScan: "ApplicationTestCoverageScan",
      },
    },
  },
  Photo: {
    Type: {
      Banner: "Banner",
    },
  },
  Stack: [
    // {
    //     'key': 'Node',
    //     'text': 'Node',
    //     'value': 'Node'
    // },
    // {
    //     'key': 'Python',
    //     'text': 'Python',
    //     'value': 'Python'
    // },
    // {
    //   key: "Java",
    //   text: "Java",
    //   value: "Java",
    // },
    {
      key: "DotNET",
      text: ".NET",
      value: "DotNET",
    },
  ],
  Clouds: {
    Azure: {
      Code: "azure",
      Name: "Azure",
    },
  },
  DeploymentMode: [
    {
      key: "Public",
      text: "Public",
      value: "Public",
      description:
        'Public mode enables you to host your AI model live behind our API gateway as well as creating a homepage for your model included in our public directory to advertise it or optionally monetise it later. You can then set your prices for your models, and sell subscription licenses to your customers. Please note, we only allow your "paid" customers to call your model via APIs, and no one else has access to your actual model files, which protects your IP rights.',
    },
    {
      key: "Private",
      text: "Private",
      value: "Private",
      description:
        "Private mode enables you to host your AI model live behind our API gateway that only you and your team can access. We also create a homepage for your models accessible only via the direct link you share with anyone. We will not showcase or include your model in our public AI directory.",
    },
  ],
  Reactions: {
    Liked: "Liked",
    Loved: "Loved",
    Inspired: "Inspired",
    Clapped: "Clapped",
  },
  Usage: {
    Api: {
      Succeeded: "Pellerex-Api-Call-Succeeded",
      Failed: "Pellerex-Api-Call-Failed",
      LimitReached: "Pellerex-Api-Call-LimitReached",
    },
  },
};

export const AppSpace = {
  Names: {
    // A copy of the name Marketplace takes for a new AppSpace: lowercase letters, digits and
    // hyphens, starting with a letter and ending with a letter or digit, at most 63 characters.
    // The original is AppSpace.DnsCompliantSlugPattern in Common/MarketplaceConstants.cs of
    // pellerex.ecosystem.core.marketplaceapi, checked by Api/Validators/CreateAppSpaceViewModelValidator.cs.
    // Marketplace stays the authority: a change there changes this copy in the same piece of work.
    ValidNewNameRegEx: /^[a-z]([-a-z0-9]{0,61}[a-z0-9])?$/,
    // The longest name the Portal takes when an AppSpace is edited, in its Edit panel and on its
    // Settings tab, where the name is letters, numbers and hyphens of either case
    // (General.Validation.RegExPatterns.AlphaNumericPlusHyphenValidationRegEx). Marketplace checks
    // no name on an edit, so this limit is the Portal's own.
    EditedNameMaximumLength: 100,
  },
};

export const Marketplace = {
  ResourceTypes: {
    Universe: "Universe",
    Tenant: "Tenant",
    Organisation: "Organisation",
    AppSpace: "AppSpace",
    App: "App",
  },
  AccessChangeMode: {
    AddRole: {
      Code: "AddRole",
      Name: "Add Role",
    },
    RemoveRole: {
      Code: "RemoveRole",
      Name: "Remove Role",
    },
    RemoveResource: {
      Code: "RemoveResource",
      Name: "Remove Resource",
    },
  },
  AccessSource: {
    ThroughTeamAssignment: {
      Code: "ThroughTeamAssignment",
      Name: "Direct Team Assignment",
    },
    ThroughDirectAssignment: {
      Code: "ThroughDirectAssignment",
      Name: "Direct User Assignment",
    },
    UserCreatedTheResource: {
      Code: "UserCreatedTheResource",
      Name: "Creator",
    },
    InheritedPermission: {
      Code: "Inherited",
      Name: "Indirect",
    },
  },
  // The longest name and description Marketplace accepts for a team.
  Teams: {
    NameMaximumLength: 100,
    DescriptionMaximumLength: 200,
  },
  // The job screen following a job by its events (JobOrchestrator/hooks/useJobEventFeed).
  JobEventFeed: {
    // The kinds of event the screen draws from, or reads the whole job again for. An event of any
    // other kind keeps its place in the order and draws nothing.
    EventKinds: {
      StatusChange: "StatusChange",
      // A person changed the limits of the job's agent budget. The event names the new limits in
      // words only, so the screen reads the whole job again to show them.
      AgentBudgetChanged: "AgentBudgetChanged",
    },
    // Why the screen stopped following a job by its events and read the whole job again.
    ResyncReasons: {
      // A sequence number was left out between the last event drawn and the next one answered.
      MissingEvent: "MissingEvent",
      // An event is about a step the job on screen does not hold.
      UnknownStep: "UnknownStep",
      // The answer is not in the form the events call promises.
      UnreadableAnswer: "UnreadableAnswer",
      // The events call failed.
      EventsUnavailable: "EventsUnavailable",
      // The whole job was answered without the sequence its events are followed from.
      NoCursor: "NoCursor",
      // The whole job was answered without the app space its events are asked for under.
      NoAppSpace: "NoAppSpace",
      // The last whole read failed, so the screen shows that failure and not the job.
      WholeReadFailed: "WholeReadFailed",
    },
    // The names the feed's measures are sent to telemetry under.
    Telemetry: {
      // The whole job was read again because its events could not be asked for, read or trusted.
      Resync: "JobEventFeedResync",
      // The whole job was read again because an event changed what an event cannot carry.
      DetailReload: "JobEventFeedDetailReload",
      // The interval the screen reads a job at changed. Zero means it reads nothing.
      PollingInterval: "JobEventFeedPollingInterval",
    },
  },
};
